import { vsModuleName as mealLogModuleName } from "../../../machines.mealLog";

import angular from "angular";

export const vsModuleName = "SlotTrak.Machines.MealLog.Sycuan";

angular.module(vsModuleName, [mealLogModuleName]);
